import React, { useContext } from "react";
import { Chip, Tooltip } from "@material-ui/core";
import { AuthContext } from "../../context/Auth/AuthContext";
import { i18n } from "../../translate/i18n";
import { Schedule as ScheduleIcon, AccessTime as AccessTimeIcon } from "@material-ui/icons";

const SessionStatusIndicator = () => {
  const { sessionConfig } = useContext(AuthContext);

  if (!sessionConfig) {
    return null;
  }

  // O backend manda "message" em português fixo; o texto vem das chaves i18n.
  const { timeoutDisabled, timeoutMinutes, configLoaded } = sessionConfig;

  // Enquanto o servidor não respondeu, não inventa um valor. O padrão chumbado
  // antigo exibia "15min" mesmo quando /auth/session-config falhava, escondendo
  // a falha atrás de um número que o servidor nunca enviou.
  if (!configLoaded) {
    return null;
  }

  if (!timeoutDisabled) {
    // Mostra o tempo real, inclusive se for curto: esconder sessões de poucos
    // minutos só dificultava perceber uma configuração errada.
    if (timeoutMinutes) {
      return (
        <Tooltip title={i18n.t("sessionStatusIndicator.expiresIn", { minutes: timeoutMinutes })}>
          <Chip
            icon={<AccessTimeIcon />}
            label={i18n.t("sessionStatusIndicator.minutes", { minutes: timeoutMinutes })}
            color="default"
            variant="outlined"
            size="small"
            style={{
              fontSize: '0.75rem',
              height: '24px',
              marginLeft: '8px',
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
              color: 'white',
              border: '1px solid rgba(255, 255, 255, 0.3)'
            }}
          />
        </Tooltip>
      );
    }
    return null;
  }

  return (
    <Tooltip title={i18n.t("sessionStatusIndicator.noExpiry")}>
      <Chip
        icon={<ScheduleIcon />}
        label={i18n.t("sessionStatusIndicator.extended")}
        color="primary"
        variant="outlined"
        size="small"
        style={{
          fontSize: '0.75rem',
          height: '24px',
          marginLeft: '8px',
          backgroundColor: 'rgba(76, 175, 80, 0.1)',
          color: 'white',
          border: '1px solid rgba(76, 175, 80, 0.5)'
        }}
      />
    </Tooltip>
  );
};

export default SessionStatusIndicator;
